import { render, staticRenderFns } from "./allocationOrderAudit.vue?vue&type=template&id=55cff26c"
import script from "./allocationOrderAudit.vue?vue&type=script&lang=js"
export * from "./allocationOrderAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports